





































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default Vue.extend({
  name: "SettingModal",
  computed: {
    ...mapGetters({
      settingMenuModal: "user/settingMenuModal",
      userIdSettingModal: "user/userIdSettingModal",
      resetUserMenu: "user/resetUserMenu"
    })
  },
  methods: {
    handleCheckAll(value: boolean) {
      if (!value) {
        this.setMenu([]);
      } else {
        const allMenu = this.menuList.map(item => item.display);
        this.setMenu(allMenu);
      }
    },
    handleCancel() {
      this.resetSettingModal();
    },
    async handleChangePass() {},
    ...mapMutations({
      resetSettingModal: "user/resetSettingModal",
      setMenu: "user/setMenu"
    }),
    ...mapActions({
      changePassword: "user/changePassword",
      updateMenu: "user/updateMenu"
    }),
    async saveMenus() {
      this.loading = true;
      try {
        await this.updateMenu({
          id: this.userIdSettingModal,
          data: {
            menu: this.settingMenuModal.userMenu
          }
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    }
  },
  data() {
    return {
      loading: false,
      checkboxGroup: [],
      menuList: [
        {
          id: 1,
          icon: "fas fa-dharmachakra",
          display: "Vòng quay",
          routerLink: "/campaign"
        },
        {
          id: 2,
          icon: "far fa-list-alt",
          display: "Danh sách trắng",
          routerLink: "/whitelist"
        },
        {
          id: 3,
          icon: "fas fa-list-alt",
          display: "Danh sách đen",
          routerLink: "/blacklist"
        },
        {
          id: 4,
          icon: "fas fa-dolly-flatbed",
          display: "Sản phẩm",
          routerLink: "/product"
        },
        {
          id: 5,
          icon: "fas fa-store",
          display: "Đại lý bán hàng",
          routerLink: "/agency"
        },
        {
          id: 6,
          icon: "fas fa-id-card",
          display: "Thẻ nông dân",
          routerLink: "/farmer"
        },
        {
          id: 7,
          icon: "fas fa-bell",
          display: "Thông báo",
          routerLink: "/notify"
        },
        {
          id: 9,
          icon: "fas fa-newspaper",
          display: "Bài viết",
          routerLink: "/news"
        },
        {
          id: 10,
          icon: "fas fa-phone-square-alt",
          display: "Topup",
          routerLink: "/topup"
        },
        {
          id: 11,
          icon: "fas fa-scroll",
          display: "Lịch sử thao tác",
          routerLink: "/log"
        },
        {
          id: 12,
          icon: "fas fa-wrench",
          display: "Cấu hình hệ thống",
          routerLink: "/settings"
        },
        {
          id: 13,
          icon: "fas fa-archive",
          display: "Mã thùng",
          routerLink: "/chatbot-box"
        },
        {
          id: 14,
          icon: "fas fa-wine-bottle",
          display: "Mã chai",
          routerLink: "/chatbot-product"
        },
        {
          id: 8,
          icon: "fas fa-user-tie",
          display: "Quản trị viên",
          routerLink: "/user"
        },
      ]
    };
  }
});
